module.exports = __webpack_public_path__ + "media/icons/clear-cebdcd56.svg";